import { BreakpointObserver } from '@angular/cdk/layout'
import { Component, ElementRef, type OnInit, ViewChild, Input } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import {
  CptGoogleTagmanagerService,
  CptSharedDataService,
  PwaService,
  TransifexService
} from '@inside-hub-app/customer-portal-shared'
import { type B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { NGXLogger } from 'ngx-logger'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcValidationService } from '../../../kc-validation.service'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { type KcClientData, type KcLoginViewData, type KcRealmData } from '../../../interfaces/kc-data.interface'
@Component({
  selector: 'customer-portal-app-revolution-login',
  templateUrl: './revolution-login.component.html'
})
export class RevolutionLoginComponent implements OnInit {
  @Input() isMobileLogin = false
  currentLang = ''

  emailRegex: string
  constructor (
    private readonly kcDataService: KcDataService,
    private readonly kcSharedDataService: CptSharedDataService,
    public breakpointObserver: BreakpointObserver,
    public cptGtmService: CptGoogleTagmanagerService,
    private readonly logger: NGXLogger,
    private readonly kcValidationService: KcValidationService,
    public transifexService: TransifexService,
    private readonly transifexTranslationsService: TranslationService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>,
    private readonly pwaService: PwaService
  ) {
    this.emailRegex = this.remoteConfigService.get('regEx.emailRegEx.pattern')
    this.registrationEnabled = this.remoteConfigService.get(
      'registrationEnabled'
    )
    this.hasSlogan = this.remoteConfigService.get('b2c.slogan.hasSlogan')
    this.sloganTranslation = this.remoteConfigService.get(
      'b2c.slogan.translation'
    )
    this.isPwa = this.pwaService.checkPwa()
    this.isMobile = this.pwaService.checkMobile()
  
    this.form = new FormGroup({
      email: new FormControl<string | null>(null, [
        Validators.maxLength(50),
        Validators.pattern(this.emailRegex)
      ]),
      password: new FormControl<string | null>(null, [
        this.kcValidationService.password
      ])
    })
  }

  @ViewChild('loginForm', { static: true })
  private readonly formRef!: ElementRef

  public form
  private readonly logo = 'assets/images/ef-logo-blue.svg'
  public background = ''

  public realmData: KcRealmData
  public clientData: KcClientData
  public viewData: KcLoginViewData
  public logoUrl = ''

  public backgroundUrl = ''
  public color = ''
  public vpn = 'assets/icons/vpn_key_24px.svg'
  public vpnUrl = ''
  public emailImage = 'assets/icons/alternate_email_24px.svg'
  public emailImageUrl = ''
  public registrationEnabled

  public showPassword = false
  public showPasswordUrl = 'assets/icons/visibility_24px.svg'
  public hidePasswordUrl = 'assets/icons/visibility_off_24px.svg'
  public loginStarted = false
  public hasSlogan
  public sloganTranslation
  public isPwa
  public isMobile

  ngOnInit (): void {
    const layoutChanges = this.breakpointObserver.observe([
      '(min-width: 1124px)'
    ])
    layoutChanges.subscribe(data => {
      this.color = data.matches ? 'white' : 'primary'
      this.backgroundUrl = data.matches
        ? `${this.kcSharedDataService.getResourcesPath()}/${this.background}`
        : ''
    })

    this.vpnUrl = `${this.kcSharedDataService.getResourcesPath()}/${this.vpn}`
    this.emailImageUrl = `${this.kcSharedDataService.getResourcesPath()}/${
      this.emailImage
    }`

    this.logoUrl = `${this.kcSharedDataService.getResourcesPath()}/${this.logo}`
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.viewData = this.kcDataService.getViewData() as KcLoginViewData

    // set initial values
    this.form.patchValue({
      email: this.viewData.username
    })
    const loginFailure = Boolean(
      this.kcDataService.getData().message?.type === 'error'
    )
    if (loginFailure) {
      this.cptGtmService.sendLoginGtmData(false)
    }
    const succes = Boolean(
      this.kcDataService.getData().message?.type === 'success'
    )
    if (succes) {
      this.cptGtmService.sendLoginSuccessData()
    }
  }

  public login (): void {
    this.loginStarted = true
    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  public toggleShowPassword (): void {
    const password = this.form.controls.password.value
    this.showPassword = !this.showPassword
    this.form.controls.password.setValue(password)
  }

  getTitleTranslation (): string {
    return this.transifexTranslationsService.translate(
      'Please log in to your myEmil Frey account',
      {
        _key: 'customerPortal.kc.login-now',
        _tags: 'kc-forms, 3.1'
      }
    )
  }
}
